import * as React from "react";

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24, color } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_45_39561)">
        <path
          d="M3.3335 5.83341C3.3335 5.39139 3.50909 4.96746 3.82165 4.6549C4.13421 4.34234 4.55814 4.16675 5.00016 4.16675H15.0002C15.4422 4.16675 15.8661 4.34234 16.1787 4.6549C16.4912 4.96746 16.6668 5.39139 16.6668 5.83341V15.8334C16.6668 16.2754 16.4912 16.6994 16.1787 17.0119C15.8661 17.3245 15.4422 17.5001 15.0002 17.5001H5.00016C4.55814 17.5001 4.13421 17.3245 3.82165 17.0119C3.50909 16.6994 3.3335 16.2754 3.3335 15.8334V5.83341Z"
          stroke={color}
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.3335 2.5V5.83333"
          stroke={color}
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.6665 2.5V5.83333"
          stroke={color}
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.3335 9.16675H16.6668"
          stroke={color}
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.8335 11.6667H5.84433"
          stroke={color}
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.3418 11.6667H8.34596"
          stroke={color}
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.8418 11.6667H10.846"
          stroke={color}
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.3457 11.6667H13.3499"
          stroke={color}
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.8457 14.1667H10.8499"
          stroke={color}
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.8418 14.1667H5.84596"
          stroke={color}
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.3418 14.1667H8.34596"
          stroke={color}
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_45_39561">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgComponent;
